import { Component, OnInit } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ContratistaService } from 'src/app/services/contratista.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-nav-bar-contratista',
  templateUrl: './nav-bar-contratista.component.html',
  styleUrls: ['./nav-bar-contratista.component.scss']
})
export class NavBarContratistaComponent implements OnInit {
  userLogged:any
xtensaBasica: any

  constructor(private loginService: LoginService, private apollo: Apollo, private contratistaService: ContratistaService) { this.userLogged = loginService.getUserData()}

  ngOnInit(): void {
    this.getContratistaById()
  }
  getContratistaById(){
    this.apollo.watchQuery<any>({
      query: this.contratistaService.getContratistaById(),
  
      variables: {
        "id": this.userLogged.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.xtensaBasica = data.contratista.xtensaBasica
      })
  }
}
